import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, signal } from '@angular/core';
import { BasisDocumentFileTemplateService } from '@zaoblako/web/core/services/basis/basis-document-file-template.service';
import { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { DocumentFileTemplateLogFindInterface } from '@zaoblako/shared/modules/catalog/dtos/document-file-template-log/document-file-template-log-find.dto';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { TimelineModule } from 'primeng/timeline';
import { CardModule } from 'primeng/card';
import { CrmTableColumn } from '@zaoblako/web/core/models/crm-table-column.interface';
import { TableComponent } from '@zaoblako/web/shared/dumbs/table/table.component';
import { DatePipe, NgIf } from '@angular/common';
import { DocumentFileTemplateTypeNamePipe } from '@zaoblako/web/shared/pipes/document-file-template-type-name.pipe';
import { ConditionalRouterLinkDirective } from '@zaoblako/web/shared/directives/conditional-router-link.directive';
import { DocumentFileTemplateTypeEnum } from '@zaoblako/shared/modules/catalog/enums/document-file-template-type.enum';

@Component({
  selector: 'crm-document-file-template-logs',
  standalone: true,
  imports: [
    ProgressSpinnerModule,
    SpinnerComponent,
    TimelineModule,
    CardModule,
    TableComponent,
    DatePipe,
    NgIf,
    DocumentFileTemplateTypeNamePipe,
    ConditionalRouterLinkDirective
  ],
  templateUrl: './document-file-template-logs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentFileTemplateLogsComponent implements OnInit {
  @Input() public readonly documentId: number;
  public items: DocumentFileTemplateLogFindInterface[] = [];
  public loading = signal(true);

  public queryParams: PaginationQueryInterface = {
    limit: 30,
    offset: 0
  };

  public count = signal<number>(0);
  public paginationLoading = signal(false);

  public readonly columns: CrmTableColumn[] = [{ label: 'Номер' }, { label: 'Дата' }, { label: 'Тип объекта' }];

  public get DocumentFileTemplateTypeEnum() {
    return DocumentFileTemplateTypeEnum;
  }

  public constructor(
    private readonly basisDocumentFileTemplateService: BasisDocumentFileTemplateService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public ngOnInit() {
    this.load();
  }

  public onScrollEnd(target: HTMLElement) {
    if (target.offsetHeight + target.scrollTop >= target.scrollHeight) {
      if (this.items.length < this.count() && !this.loading() && !this.paginationLoading()) {
        this.paginationLoading.set(true);
        this.queryParams.offset += this.queryParams.limit;
        this.load({ concat: true });
      }
    }
  }

  public toItem(item: any): DocumentFileTemplateLogFindInterface {
    return item as DocumentFileTemplateLogFindInterface;
  }

  private load({ concat } = { concat: false }) {
    if (!concat) {
      this.loading.set(true);
    }

    this.basisDocumentFileTemplateService.getLog(this.documentId, this.queryParams).subscribe({
      next: (data) => {
        this.count.set(data.count);
        this.items = concat ? this.items.concat(data.items) : data.items;

        this.loading.set(false);
        this.paginationLoading.set(false);
        this.cdRef.markForCheck();
      }
    });
  }
}
